export const siteSettings = {
  name: "Nova Finex",
  link: "https://novafinex.live",
  email: "support@novafinex.live",
  appLink: "https://app.novafinex.live",
};
